<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row footer" v-if="birthdays.length > 0">
          <div class="col-md-12 col-lg-12 col-xl-12 birthContainer">
            <marquee-text :duration="30" :repeat="1" :reverse="false">
              <span class="birthSpan" v-for="item in birthdays" :key="item.id"
                >{{ item.firstName + " " + item.lastName }}'s birthday is
                {{ getBirthday(item.birthday) }}</span
              >
            </marquee-text>
          </div>
        </div>
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">
                  Welcome {{ currentUser.user.fullName }}
                </h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Dashboard</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3">
              <div
                class="card dash-widget"
                style="background-color: #5F3B7E !important; color: #fff !important; border: 1px solid #5F3B7E;"
              >
                <div class="card-body">
                  <span class="dash-widget-icon"
                    ><i class="fa fa-user" style="color: #fff !important;"></i
                  ></span>
                  <div class="dash-widget-info">
                    <h3 style="color: #fff !important;">
                      {{ totalEmployees }}
                    </h3>
                    <span>Employees</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3">
              <div
                class="card dash-widget"
                style="background-color: #E24F55 !important; color: #fff !important; border: 1px solid #E24F55;"
              >
                <div class="card-body">
                  <span class="dash-widget-icon"
                    ><i
                      class="fa fa-briefcase"
                      style="color: #fff !important;"
                    ></i
                  ></span>
                  <div class="dash-widget-info">
                    <h3 style="color: #fff !important;">
                      {{ totalApplications }}
                    </h3>
                    <span>Applications</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3">
              <div
                class="card dash-widget"
                style="background-color: #1573BE !important; color: #fff !important; border: 1px solid #1573BE;"
              >
                <div class="card-body">
                  <span class="dash-widget-icon"
                    ><i
                      class="fa fa-building"
                      style="color: #fff !important;"
                    ></i
                  ></span>
                  <div class="dash-widget-info">
                    <h3 style="color: #fff !important;">
                      {{ totalPendingLeave }}
                    </h3>
                    <span>Pending Leaves</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3">
              <div
                class="card dash-widget"
                style="background-color: #B97DC7 !important; color: #fff !important; border: 1px solid #B97DC7;"
              >
                <div class="card-body">
                  <span class="dash-widget-icon"
                    ><i class="fa fa-user" style="color: #fff !important;"></i
                  ></span>
                  <div class="dash-widget-info">
                    <h3 style="color: #fff !important;">
                      {{
                        totalCasualWorker
                          .toString()
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                      }}
                    </h3>
                    <span>Total Casual Workers</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Statistics Widget -->
          <div class="row">
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex h-100">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">On Leave</h4>
                  <div
                    class="leave-info-box"
                    v-for="item in todayAbsence.slice(0, 5)"
                    :key="item.id"
                  >
                    <div class="media align-items-center">
                      <router-link to="/profile" class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></router-link>
                      <div class="media-body">
                        <div class="text-sm my-0">
                          {{
                            item.employee.firstName +
                              " " +
                              item.employee.lastName
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center mt-3">
                      <div class="col-6">
                        <h6 class="mb-0">
                          From:
                          {{ new Date(item.fromDate).toLocaleDateString() }}
                        </h6>
                        <h6 class="mb-0">
                          To:
                          {{ new Date(item.toDate).toLocaleDateString() }}
                        </h6>
                        <span class="text-sm text-muted">Leave Date</span>
                      </div>
                      <div class="col-6 text-right">
                        <!-- <span
                          class="badge bg-inverse-info"
                          v-if="item.status == 0"
                          >Pending</span
                        > -->
                        <span
                          class="badge bg-inverse-success"
                          v-if="item.status == 1"
                          >Approve</span
                        >
                        <span
                          class="badge bg-inverse-danger"
                          v-if="item.status == 2"
                          >Reject</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="load-more text-center"
                    v-if="upcomingLeaves.length > 0"
                  >
                    <a class="text-dark" href="javascript:void(0);"
                      >Load More</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex h-100">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">Pending Leaves</h4>
                  <div
                    class="leave-info-box"
                    v-for="item in upcomingLeaves.slice(0, 5)"
                    :key="item.id"
                  >
                    <div class="media align-items-center">
                      <router-link to="/profile" class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></router-link>
                      <div class="media-body">
                        <div class="text-sm my-0">
                          {{
                            item.employee.firstName +
                              " " +
                              item.employee.lastName
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center mt-3">
                      <div class="col-6">
                        <h6 class="mb-0">
                          {{ new Date(item.fromDate).toLocaleDateString() }}
                        </h6>
                        <span class="text-sm text-muted">Leave Date</span>
                      </div>
                      <div class="col-6 text-right">
                        <span
                          class="badge bg-inverse-info"
                          v-if="item.status == 0"
                          >Pending</span
                        >
                        <span
                          class="badge bg-inverse-success"
                          v-if="item.status == 1"
                          >Approve</span
                        >
                        <span
                          class="badge bg-inverse-danger"
                          v-if="item.status == 2"
                          >Reject</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="load-more text-center"
                    v-if="upcomingLeaves.length > 0"
                  >
                    <router-link
                      to="/leaves"
                      class="text-dark"
                      href="javascript:void(0);"
                      >Load More</router-link
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Statistics Widget -->

          <div class="row">
            <div class="col-md-12 col-lg-6 col-xl-6 d-flex h-100">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">Upcoming Resignation</h4>
                  <div
                    class="leave-info-box"
                    v-for="item in upcomingResignations.slice(0, 5)"
                    :key="item.id"
                  >
                    <div class="media align-items-center">
                      <router-link to="/profile" class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></router-link>
                      <div class="media-body">
                        <div class="text-sm my-0">
                          {{
                            item.employee.firstName +
                              " " +
                              item.employee.lastName
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center mt-3">
                      <div class="col-6">
                        <h6 class="mb-0">
                          {{ new Date(item.noticeDate).toLocaleDateString() }}
                        </h6>
                        <span class="text-sm text-muted">Notice Date</span>
                      </div>
                      <div class="col-6 text-right">
                        <span
                          class="badge bg-inverse-success"
                          v-if="item.status == 1"
                          >Approve</span
                        >
                        <span
                          class="badge bg-inverse-danger"
                          v-if="item.status == 2"
                          >Declined</span
                        >
                        <span
                          class="badge bg-inverse-purple"
                          v-if="item.status == 0 && !item.exitInterview"
                          >New</span
                        >
                        <span
                          class="badge bg-inverse-purple"
                          v-if="item.status == 0 && item.exitInterview"
                          >Pending Interview</span
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    class="load-more text-center"
                    v-if="upcomingResignations.length > 0"
                  >
                    <router-link to="/resignation" class="text-dark"
                      >Load More</router-link
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-6 col-xl-6 d-flex h-100">
              <div class="card flex-fill">
                <div class="card-body">
                  <h4 class="card-title">Today Absent</h4>
                  <!-- <div
                    class="leave-info-box"
                    v-for="item in todayAbsence"
                    :key="item.id"
                  >
                    <div class="media align-items-center">
                      <router-link to="/profile" class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="media + item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></router-link>
                      <div class="media-body">
                        <div class="text-sm my-0">
                          {{
                            item.employee.firstName +
                              " " +
                              item.employee.lastName
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="row align-items-center mt-3">
                      <div class="col-6">
                        <h6 class="mb-0">
                          {{ new Date().toLocaleDateString() }}
                        </h6>
                        <span class="text-sm text-muted">Leave Date</span>
                      </div>
                      <div class="col-6 text-right">
                        <span
                          class="badge bg-inverse-success"
                          v-if="item.status == 1"
                          >Approve</span
                        >
                      </div>
                    </div>
                  </div> -->
                  <div
                    class="load-more text-center"
                    v-if="todayAbsence.length > 0"
                  >
                    <a class="text-dark" href="javascript:void(0);"
                      >Load More</a
                    >
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 d-flex h-100">
              <div class="card card-table flex-fill">
                <div class="card-header">
                  <h3 class="card-title mb-0">Salary Payments</h3>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table
                      class="table custom-table table-nowrap mb-0"
                      v-if="lastSalaryPayment.length > 0"
                    >
                      <thead>
                        <tr>
                          <th>Invoice ID</th>
                          <th>Employee</th>
                          <th>Designation</th>
                          <th>Paid Date</th>
                          <th>Paid Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in lastSalaryPayment" :key="item.id">
                          <td>
                            {{ item.reference }}
                          </td>
                          <td>
                            <h2>
                              <a href="#">{{
                                item.employee.firstName +
                                  " " +
                                  item.employee.lastName
                              }}</a>
                            </h2>
                          </td>
                          <td>{{ item.employee.destination.name }}</td>
                          <td>
                            {{
                              new Date(
                                item.salaryPayment.createdAt
                              ).toLocaleDateString()
                            }}
                          </td>
                          <td>
                            ₦{{
                              item.netSalary
                                .toString()
                                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="card-footer" v-if="lastSalaryPayment.length > 0">
                  <router-link to="/payments">View all payments</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { employeeService } from "@/services/employeeService.js";
import Vue from "vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      currentUser: authenticationService.currentUserValue,
      company: authenticationService.currentOfficeValue,
      totalEmployees: 0,
      totalApplications: 0,
      totalCasualWorker: 0,
      totalPrevSalaries: 0,
      todayAbsence: [],
      upcomingLeaves: [],
      upcomingResignations: [],
      lastSalaryPayment: [],
      birthdays: [],
      totalPendingLeave: [],
      media: "data:image/jpeg;base64,"
    };
  },
  methods: {
    getSummary() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getDashboardCountSummary(unit.id).then(o => {
        this.totalEmployees = o.totalEmployees;
        this.totalApplications = o.totalApplications;
        this.totalCasualWorker = o.totalCasualWorker;
        this.totalPrevSalaries = o.totalPrevSalaries;
        console.log(o);
      });
    },
    getLeaveSummary() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getHRLeaveSummary(unit.id).then(o => {
        this.totalEmployees = o.totalEmployees;
        this.totalAbsence = o.totalAbsence;
        this.totalPendingLeave = o.totalPendingLeave;
      });
    },
    getTodayAbsence() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getTodayAbsence(unit.id).then(o => {
        this.todayAbsence = o;
      });
    },
    getUpcomingLeaves() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getUpcomingLeaves(unit.id).then(o => {
        this.upcomingLeaves = o;
      });
    },
    getUpcomingResignations() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getUpcomingResignations(unit.id).then(o => {
        this.upcomingResignations = o;
      });
    },
    getPaidSalaries() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getLastSalaryPayment(unit.id).then(o => {
        this.lastSalaryPayment = o;
      });
    },
    getUpcomingBirthday() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getUpcomingBirthday(unit.id).then(o => {
        this.birthdays = o;
      });
    },
    getBirthday(dateOfbirth) {
      console.log(dateOfbirth);
      var currentDate = new Date(dateOfbirth).getDate();
      var currentMonth = new Date(dateOfbirth).getMonth();
      var currentYear = new Date().getFullYear();

      var birthday = new Date(currentYear, currentMonth, currentDate);
      console.log(currentMonth);
      var dayNum = birthday.getDay();
      console.log(dayNum);
      switch (dayNum) {
        case 0:
          return "Sunday";
        case 1:
          return "Monday";
        case 2:
          return "Tuesday";
        case 3:
          return "Wednesday";
        case 4:
          return "Thursday";
        case 5:
          return "Friday";
        case 6:
          return "Saturday";
      }
    }
  },
  mounted() {
    this.getSummary();
    this.getLeaveSummary();
    this.getTodayAbsence();
    this.getUpcomingLeaves();
    this.getUpcomingResignations();
    this.getUpcomingBirthday();
    $(document).ready(function() {
      //barChart();
      //lineChart();

      $(window).resize(function() {
        window.barChart.redraw();
        window.lineChart.redraw();
      });
    });
    function barChart() {
      window.barChart = Morris.Bar({
        element: "bar-chart",
        data: [
          { y: "2006", a: 100, b: 90 },
          { y: "2007", a: 75, b: 65 },
          { y: "2008", a: 50, b: 40 },
          { y: "2009", a: 75, b: 65 },
          { y: "2010", a: 50, b: 40 },
          { y: "2011", a: 75, b: 65 },
          { y: "2012", a: 100, b: 90 }
        ],
        xkey: "y",
        ykeys: ["a", "b"],
        labels: ["Total Income", "Total Outcome"],
        lineColors: ["#ff9b44", "#fc6075"],
        lineWidth: "3px",
        barColors: ["#ff9b44", "#fc6075"],
        resize: true,
        redraw: true
      });
    }
    function lineChart() {
      window.lineChart = Morris.Line({
        element: "line-chart",
        data: [
          { y: "2006", a: 50, b: 90 },
          { y: "2007", a: 75, b: 65 },
          { y: "2008", a: 50, b: 40 },
          { y: "2009", a: 75, b: 65 },
          { y: "2010", a: 50, b: 40 },
          { y: "2011", a: 75, b: 65 },
          { y: "2012", a: 100, b: 90 }
        ],
        xkey: "y",
        ykeys: ["a", "b"],
        labels: ["Total Sales", "Total Revenue"],
        lineColors: ["#ff9b44", "#fc6075"],
        lineWidth: "3px",
        resize: true,
        redraw: true
      });
    }
  },
  name: "index"
};
</script>



// WEBPACK FOOTER //
// src/components/index.vue